<ng-container *ngIf="!showDone && !isLoading">
    <p-tabView
        [(activeIndex)]="tabIndex"
        orientation="right"
        (onChange)="selectTab($event)">
        <p-tabPanel header="Details">
            <ng-container *ngTemplateOutlet="workCategoryDetailsForm"></ng-container>
        </p-tabPanel>
        <p-tabPanel header="Sub-categories" *ngIf="viewStatus === 'edit'">
            <ng-container *ngTemplateOutlet="workSubCategories"></ng-container>
        </p-tabPanel>
    </p-tabView>
</ng-container>

<ng-template #workCategoryDetailsForm>
    <div class="cas-pad cas-flex-column-limit">
        <form [formGroup]="editForm" >
            <acabim-form-block  labelWidth="9" [colonize]="true">
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Name</acabim-form-input-label>
                    <acabim-form-input-content>
                        <input formControlName="name" pInputText>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>CBI class</acabim-form-input-label>
                    <acabim-form-input-content>
                        <p-dropdown
                            *ngIf="cbiClassOptions.length < 1"
                            [options]="cbiClassOptionsGrouped"
                            formControlName="cbiClass"
                            optionLabel="label"
                            optionValue="value"
                            class="push-down"
                            [group]="true"
                            [filter]="true"
                            placeholder="CBI class"></p-dropdown>
                        <p-dropdown
                            *ngIf="cbiClassOptions.length > 0"
                            [options]="cbiClassOptions"
                            formControlName="cbiClass"
                            optionLabel="label"
                            optionValue="value"
                            class="push-down"
                            placeholder="CBI class"></p-dropdown>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Priority</acabim-form-input-label>
                    <acabim-form-input-content>
                        <p-dropdown
                            [options]="priorityOptions"
                            formControlName="defaultPriority"
                            optionLabel="label"
                            optionValue="value"
                            class="push-down"
                            placeholder="Default priority"></p-dropdown>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper *ngIf="viewStatus !== 'add'">
                    <acabim-form-input-label>Status</acabim-form-input-label>
                    <acabim-form-input-content>
                        <p-dropdown
                            [options]="statusOptions"
                            formControlName="status"
                            optionLabel="label"
                            optionValue="value"
                            class="push-down"
                            placeholder="Status"></p-dropdown>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
            </acabim-form-block>
            <div class="cas-action-buttons cas-action-buttons-bottom">
                <button (click)="cancel()">Cancel</button>
                <button *ngIf="viewStatus === 'edit'" class="cas-button-action cas-button-right" (click)="update()">Update</button>
                <button *ngIf="viewStatus === 'add'" class="cas-button-action cas-button-right" (click)="add()">Add</button>
            </div>
        </form>
    </div>
</ng-template>

<ng-template #workSubCategories>
    <acabim-admin-work-order-subcategory-management
        (cancelled)="cancel()"
        [cbiClassOptions]="cbiClassOptions"
        [cbiClassOptionsGrouped]="cbiClassOptionsGrouped"
        [workCategoryDetails]="workCategoryDetails"></acabim-admin-work-order-subcategory-management>
</ng-template>

<ng-container *ngIf="showDone && !isLoading">
    <div class="cas-info">
        <h4>Done!</h4>
        <p *ngIf="viewStatus === 'edit'">Successfully updated work category</p>
        <p *ngIf="viewStatus === 'add'">Successfully added new work category</p>
        <button class="cas-button-action" (click)="close()">Close</button>
    </div>
</ng-container>

<ng-container *ngIf="!showDone && isLoading">
    <acabim-loading-view></acabim-loading-view>
</ng-container>
